<template>
  <div>
    <custom-callout
      controlled
      has-toggle
      :opened="value.opened"
      @click:open="toggle()"
    >
      <div class="row d-flex align-items-center py-2 pr-3">
        <div class="col-12 col-md">
          <div class="data-name">Estatus:</div>
          <custom-balloon
            :background-color="value.status?.color"
            dot
            :text="value.status?.name"
          />
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Estudiante:</div>
          <div>
            {{ value.student?.id | empty }} -
            {{ value.student?.name | empty }}
          </div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Servicio:</div>
          <div>{{ value.disciplineType?.name | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Fecha de Servicio:</div>
          <div>{{ value.serviceDate | date }}</div>
        </div>

        <div class="col-12 col-md-2 d-flex justify-content-end">
          <drop-down :items="actions" />
        </div>

        <div class="w-100 px-3">
          <hr />
        </div>

        <div class="col-12 col-md">
          <div class="data-name">Hora de Servicio:</div>
          <div>{{ value.serviceStartTime | time }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Proveedor:</div>
          <div>{{ value.company?.name | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Especialista:</div>
          <div>{{ value.specialist?.name | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Montor a Reclamar:</div>
          <div>{{ value.costAmount | price }}</div>
        </div>

        <div class="col-12 col-md-2" />
      </div>
      <template #edition>
        <div class="bg-secondary-3 p-2">
          <!-- acción de información adicional -->
          <div v-if="isHistory" class="bg-white p-3 rounded mr-0 ml-0">
            <div class="mb-3">
              <i class="fas fa-history text-green" />
              <b class="ml-2">
                Historial del Estatus
              </b>
            </div>
            <history :data="history" @clean="initHistory" @load="getHistory" />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
//utils
import moment from 'moment';

//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//components
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';

//local components
import History from './History.vue';

//services
import { getBatchDetailLog } from '@/modules/medicaid/medicaid-claim.api';

//constants
const HISTORY_SIZE = 5;

export default {
  name: 'MedicaidClaimBatchRowResult',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    History,
  },
  filters: {
    time(value) {
      return value ? moment(value, 'HH:mm:ss').format('hh:mm A') : '-';
    },
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      section: null,
      history: {
        page: 0,
        total: 0,
        size: HISTORY_SIZE,
        items: [],
      },
    };
  },
  computed: {
    sections() {
      return Object.freeze({
        History: 0,
      });
    },
    actions() {
      return [
        {
          name: 'history',
          label: 'Historial de Estatus',
          icon: 'fas fa-history text-green',
          click: () => this.toggle(this.sections.History, false),
        },
      ];
    },
    isHistory() {
      return this.section === this.sections.History;
    },
  },
  methods: {
    toggle(section, toggle = true) {
      this.section = section ?? this.sections.History;
      if (toggle) this.value.opened = !this.value.opened;
      else this.value.opened = true;

      if (this.isHistory && this.value.opened) this.getHistory();
    },
    cancel() {
      this.section = null;
      this.value.opened = false;
    },
    async getHistory(page = 1) {
      if (this.history.page === page) return;
      const { batchId, id } = this.value;
      const { data } = await getBatchDetailLog(batchId, id, {
        page,
        size: this.history.size,
      });
      this.history.page = page;
      this.history.total = data.totalItemCount;
      this.history.items = [...this.history.items, ...data.data];
    },
    initHistory() {
      this.history.page = 0;
      this.history.total = 0;
      this.history.size = HISTORY_SIZE;
      this.history.items = [];
    },
  },
};
</script>

<style scoped>
.bg-green-gray {
  background-color: #ebf1ee !important;
}
</style>
